import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h1`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
`;

const OrderList = styled.div`
  margin-top: 20px;
`;

const OrderItem = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const OrderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const OrderLabel = styled.span`
  font-weight: bold;
  color: #555;
`;

const OrderValue = styled.span`
  color: #333;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const PageButton = styled.button`
  padding: 10px 15px;
  margin: 0 5px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #0056b3;
  }
`;

const ToggleButton = styled.button`
  margin-bottom: 10px;
  padding: 10px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #45a049;
  }
`;



const RefundHistory = () => {
  const [orderHistory, setOrderHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isInfoVisible, setIsInfoVisible] = useState(false); // 설명 표시 여부 상태

  const handleToggleInfo = () => {
    setIsInfoVisible((prev) => !prev); // 버튼 클릭 시 상태 토글
  };

  const ordersPerPage = 5;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrderHistory = async () => {
      try {
        const response = await fetch(`/Acution/order-history?page=${currentPage}&limit=${ordersPerPage}`, {
          credentials: 'include',
        });
        const data = await response.json();
        if (data && data.orders) {
          setOrderHistory(data.orders);
        } else {
          console.error('No order history found.');
        }
      } catch (error) {
        console.error('Error fetching order history:', error);
      }
    };

    fetchOrderHistory();
  }, [currentPage]);

  const totalPages = Math.ceil(orderHistory.totalCount / ordersPerPage);

  return (
    <Container>
      {isInfoVisible && (
        <p>
          예매 대행 완료시에 검수 완료, 검수 실패시 두가지 상태를 필터링해서 목록으로 확인
        </p>
      )}
      <Title>환불 내역</Title>
      <OrderList>
        {orderHistory.map(order => (
          <OrderItem key={order.menu_id}>
                 <OrderRow>
              <OrderLabel>쿠폰 코드:</OrderLabel>
              <OrderValue>{order.coupon_code}</OrderValue>
            </OrderRow>
            <OrderRow></OrderRow>
            <OrderRow>
              <OrderLabel>영화 제목:</OrderLabel>
              <OrderValue>{order.movie_title}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>상영 일자:</OrderLabel>
              <OrderValue>{order.date}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>상영 시간:</OrderLabel>
              <OrderValue>{order.screening_time}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>좌석 정보:</OrderLabel>
              <OrderValue>{order.actual_seat_number || order.seat_number}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>금액:</OrderLabel>
              <OrderValue>{order.price} 원</OrderValue>
            </OrderRow>
          </OrderItem>
        ))}
      </OrderList>
      <Pagination>
        <PageButton
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          이전
        </PageButton>
        <PageButton
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          다음
        </PageButton>
      </Pagination>
    </Container>
  );
};

export default RefundHistory;
